<template>
  <div
    class="cp-video-card"
  >
    <div @click="openModal">
      <div class="container-img">
        <img
          :src="video.thumbnail"
          :alt="video.title"
          loading="lazy"
          width="320"
          height="180"
        >
        <div class="icon-container">
          <svg class="icon icon-banner-slider-video-play">
            <defs>
              <linearGradient
                id="renault-gradient"
                x1="6.96096"
                y1="55.1746"
                x2="62.3076"
                y2="49.4286"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#9797FF"></stop>
                <stop
                  offset="1"
                  stop-color="#EC35BF"
                ></stop>
              </linearGradient>
            </defs>
            <use xlink:href="#icon-banner-slider-video-play"></use>
          </svg>
        </div>
      </div>
      <div class="-bottom">
        <div class="bottom-title">
          {{ video.title }}
        </div>
      </div>
    </div>

    <media-modal
      v-if="activeModal"
      :source="whatSource"
      :media="video"
      :type-player="typePlayer"
      :display-vodalys="displayVodalys"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import MediaModal from './MediaModal';

export default {
  components: {
    MediaModal,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeModal: false,
    }
  },
  computed: {
    whatSource() {
      const videosList = [this.video.video_vodalys_id, this.video.video_id, this.video.video_m3u_url, this.video.video_iframe];
      return videosList;
    },
  },
  methods: {
    openModal() {
      this.activeModal = true;
      document.body.classList.add('modal-is-open');
    },
    closeModal() {
      this.activeModal = false;
      document.body.classList.remove('modal-is-open');
    },
  },
}
</script>
